import React from 'react';
import './ChipSkeletonLoader.scss';

const DEFAULT_CHIP_WIDTHS = [112, 88, 56, 64];

const ChipSkeletonLoader = ({ chipHeight = null, chipWidths = DEFAULT_CHIP_WIDTHS, ariaLabel = 'Loading', className='' }) => (
  <div className={`chip-skeleton-loader d-flex align-items-center ${className}`} aria-busy="true" aria-label={ariaLabel}>
    {chipWidths.map((width, index) => (
      <div key={index} className="chip-skeleton-loader__chip shimmer" style={{ width: `${width}px`, height: `${chipHeight}px` }} />
    ))}
  </div>
);

export default ChipSkeletonLoader;
